import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Icon from '../Icon';

const mailPropertyTypes = {
  dPath: PropTypes.string,
  title: PropTypes.string,
  fill: PropTypes.string,
};

type MailProperties = InferProps<typeof mailPropertyTypes>;

const Mail = ({
  dPath, title, fill, ...properties
} : MailProperties) => (
  <Icon
    // eslint-disable-next-line max-len
    dPath="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    title="Mail"
    fill="var(--grey-dark)"
    {...properties}
  />
);

Mail.propTypes = mailPropertyTypes;

export default Mail;
